/* eslint-disable */
// Written BY HAND -- not generated (see labels.js). Every GraphQL operation the
// Messages inbox sends lives here so tools/refresh-graphql-schema.js validates
// it against the deployed schema.
//
// The three models are read-only for signed-in users; replying and marking a
// conversation read are the two Mutations served by the buyerMessages Lambda.
// Neither takes an owner: the caller comes from the verified identity.

export const CONVERSATION_FIELDS = `id owner channel channelAccountRef externalConversationId otherPartyUsername title
  externalItemRef orderId externalOrderId orderPlacedAt listingId listingTitle listingSku lastMessageAt
  lastMessageSnippet lastMessageDirection lastInboundAt readThroughAt readState readAt readBy repliesClosed kind`;

// All conversations, newest first; `lastMessageAt: { ge }` stops it at the inbox window (INBOX_DAYS).
export const conversationsByOwnerLastMessage = /* GraphQL */ `
  query ConversationsByOwnerLastMessage(
    $owner: String
    $lastMessageAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    conversationsByOwnerLastMessage(
      owner: $owner
      lastMessageAt: $lastMessageAt
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items { ${CONVERSATION_FIELDS} }
      nextToken
    }
  }
`;

// Unread conversations, newest first. The sort key is readState#lastMessageAt,
// so beginsWith on the first part selects the unread partition IN time order.
export const conversationsByOwnerReadState = /* GraphQL */ `
  query ConversationsByOwnerReadState(
    $owner: String
    $readStateLastMessageAt: ModelConversationByOwnerReadStateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    conversationsByOwnerReadState(
      owner: $owner
      readStateLastMessageAt: $readStateLastMessageAt
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items { ${CONVERSATION_FIELDS} }
      nextToken
    }
  }
`;

export const getConversation = /* GraphQL */ `
  query GetConversation($id: ID!) {
    getConversation(id: $id) { ${CONVERSATION_FIELDS} }
  }
`;

export const conversationMessagesByConversation = /* GraphQL */ `
  query ConversationMessagesByConversation($conversationId: ID, $sortDirection: ModelSortDirection, $limit: Int, $nextToken: String) {
    conversationMessagesByConversation(conversationId: $conversationId, sortDirection: $sortDirection, limit: $limit, nextToken: $nextToken) {
      items { id conversationId direction senderUsername recipientUsername subject body media sentAt sentBy sourceLanguage translatedLanguage translatedBody }
      nextToken
    }
  }
`;

export const conversationSyncStatesByOwner = /* GraphQL */ `
  query ConversationSyncStatesByOwner($owner: String, $limit: Int, $nextToken: String) {
    conversationSyncStatesByOwner(owner: $owner, limit: $limit, nextToken: $nextToken) {
      items { id channel channelAccountRef status lastError lastAttemptAt lastSuccessAt }
      nextToken
    }
  }
`;

export const sendConversationReply = /* GraphQL */ `
  mutation SendConversationReply($conversationId: ID!, $text: String!, $seenInboundAt: AWSDateTime, $clientMessageId: String) {
    sendConversationReply(conversationId: $conversationId, text: $text, seenInboundAt: $seenInboundAt, clientMessageId: $clientMessageId) {
      id conversationId direction senderUsername recipientUsername subject body media sentAt sentBy
    }
  }
`;

// OPT-461: translate a thread's inbound messages into the seller's language. The Lambda's rows come from its own
// listMessages, which does not select non-null fields such as conversationId, owner or channel, so selecting them
// would error: exactly these four, merged by id.
export const translateConversation = /* GraphQL */ `
  mutation TranslateConversation($conversationId: ID!) {
    translateConversation(conversationId: $conversationId) { id sourceLanguage translatedLanguage translatedBody }
  }
`;

export const markConversationRead = /* GraphQL */ `
  mutation MarkConversationRead($conversationId: ID!, $seenInboundAt: AWSDateTime) {
    markConversationRead(conversationId: $conversationId, seenInboundAt: $seenInboundAt) { ${CONVERSATION_FIELDS} }
  }
`;

// Account names for the account label on each conversation. `password` (the
// eBay token) is deliberately NOT selected.
export const listMessageAccounts = /* GraphQL */ `
  query ListMessageAccounts($limit: Int, $nextToken: String) {
    listMarketplaceAccounts(limit: $limit, nextToken: $nextToken) {
      items { id username type }
      nextToken
    }
  }
`;

// OPT-68: send the first (or next) message on a Poshmark order from the Order
// Queue. Takes the Sellary order id only; the caller is the verified identity.
export const startOrderConversation = /* GraphQL */ `
  mutation StartOrderConversation($orderId: ID!, $text: String!) {
    startOrderConversation(orderId: $orderId, text: $text) { conversationId confirmed }
  }
`;

// OPT-81: the item card at the top of a thread. Order lines, matches and
// inventory go through utils/omsGraphqlBatch `batched`, so the two selections
// below are what it interpolates; the Validate* documents have exactly the
// shape it builds so graphql:check covers them (as omsCancellations.js does).
export const ITEM_MATCH_FIELDS = `id orderLineId inventoryId state`;
export const ITEM_INVENTORY_FIELDS = `id sku title status images location`;

export const conversationItemOrderLines = /* GraphQL */ `
  query ConversationItemOrderLines($orderId: ID, $limit: Int, $nextToken: String) {
    orderLinesByOrder(orderId: $orderId, limit: $limit, nextToken: $nextToken) {
      items { id sku titleSnapshot quantity removed }
      nextToken
    }
  }
`;

export const conversationItemListing = /* GraphQL */ `
  query ConversationItemListing($id: ID!) {
    getListing(id: $id) { id inventory { ${ITEM_INVENTORY_FIELDS} } }
  }
`;

export const conversationItemBySku = /* GraphQL */ `
  query ConversationItemBySku($owner: String, $sku: ModelStringKeyConditionInput, $limit: Int, $nextToken: String) {
    lookupByOwnerAndSKU(owner: $owner, sku: $sku, limit: $limit, nextToken: $nextToken) {
      items { ${ITEM_INVENTORY_FIELDS} }
      nextToken
    }
  }
`;

export const ValidateConversationItemMatches = /* GraphQL */ `query ValidateConversationItemMatches($v0: ID) {
  a0: orderMatchesByLine(orderLineId: $v0, limit: 200) { items { ${ITEM_MATCH_FIELDS} } nextToken }
}`;

export const ValidateConversationItemInventory = /* GraphQL */ `query ValidateConversationItemInventory($v0: ID!) {
  a0: getInventory(id: $v0) { ${ITEM_INVENTORY_FIELDS} }
}`;
